/**
 * Add JS
 *
 * @module
 */

/**
 * Create a Promise which fulfills on the load event of a script element.
 *
 * @private
 * @param {HTMLScriptElement} script
 * @return {Promise}
 */
function addScriptCallbacks(script) {
    return new Promise((resolve, reject) => {
        script.addEventListener('load', resolve);
        script.addEventListener('error', reject);
    });
}

/**
 * Add a script to the document so it gets loaded and parsed.
 *
 * @private
 * @param {HTMLScriptElement} script
 * @param {string} url
 * @return {void}
 */
function loadScript(script, url) {
    script.src = url;
    document.head.appendChild(script);
}

/**
 * Load a JS file synchronously and return a Promise which fulfills when the file has loaded.
 *
 * @param {string} url
 * @return {Promise}
 */
export function loadSync(url) {
    console.log('Freesite2020.addJS url:', url);
    const script = document.createElement('script');
    const hasLoaded = addScriptCallbacks(script);
    loadScript(script, url);
    return hasLoaded;
}

/**
 * Load a JS file asynchronously and return a Promise which fulfills when the file has loaded.
 *
 * @param {string} url
 * @return {Promise}
 */
export function loadAsync(url) {
    console.log('Freesite2020.addAsyncJS url:', url);
    const script = document.createElement('script');
    const hasLoaded = addScriptCallbacks(script);
    script.async = true;
    loadScript(script, url);
    return hasLoaded;
}
